export const SPLIT_EVENTS = {
  SRP_engagement_click: 'mb_srp_engagement_click',
  A1_click: 'mb_collections_a1_click',
  Variants_click: 'mb_variation_click',
  Open_Qv: 'mb_pc_open_qv',
  Open_PDP: 'mb_pc_open_pdp',
};
